import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {connect} from "react-redux";
import {Auth} from "aws-amplify";
import Header from "../Headers/Header";
import AgentHome from "./agentHome";
import axios from "axios";
import configurations from "../../../configurations";
import Loader from "../../loader";
import ErrorDialog from '../../../ErrorDialog/ErrorDialog';
import ShimmerDashboard from '../../../Assets/Loaders/ShimmerEffect';


class RootComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            loaderShow : false,
            userLoggedIn : false,
            agentId : "",
            clientId : "",
            associationId : "",
            clientName : "",
            defaultEmpid : '',
            parentBrokerId:"",
            parentClientId:"",
            mode: "",
            errorDialogOpen: false,
            errorMessage: '',   
        }
    }
    componentWillUnmount() {
        this.setState = (state,callback)=>{
            return;
        };
    }

    showErrorDialog = (message) => {
        this.setState({ errorDialogOpen: true, errorMessage: message });
    };
    async componentDidMount() {
        try {
            this.setState({ loaderShow: true });
    
            if (localStorage.getItem('launchAgent')) {
                const agentDetails = JSON.parse(sessionStorage.getItem('STATE_PARAM'));
                sessionStorage.setItem('username', agentDetails.agentName);
                sessionStorage.setItem('phone', agentDetails.agentPhone);
                sessionStorage.setItem('USER_NAME', agentDetails.agentName);
                this.props.setUserData(agentDetails.brokerId, agentDetails.clientId, agentDetails.associationId);
    
                const clientRes = await axios.get(`${configurations.baseUrl}/employer/getClientInfo/${agentDetails.clientId}`);
                const userData = clientRes.data.response;
                if (!userData) throw new Error('Client Info is empty');
    
                const agentRes = await axios.get(`${configurations.baseUrl}/agentlogin/getAgentById/${agentDetails.brokerId}`);
                const agentData = agentRes.data.response;
                if (!agentData) throw new Error('Agent data is empty');
    
                this.setState({
                    associationId: agentData.associationId,
                    defaultEmpid: agentData.defaultEmpid || '',
                    agentId: agentData.brokerId,
                    loaderShow: false,
                    userLoggedIn: true,
                    clientId: userData.clientId,
                    clientName: userData.clientName
                });
    
                sessionStorage.setItem('USER_DATA', JSON.stringify({
                    agentId: agentData.brokerId,
                    clientId: userData.clientId,
                    associationId: agentData.associationId,
                    clientName: userData.clientName,
                    defaultEmpid: agentData.defaultEmpid || '',
                    role: agentData.role || "Agent",
                }));
    
                sessionStorage.setItem('clientName', userData.clientName);
                sessionStorage.setItem('customerServiceNo', userData.customerServiceNo);
    
            } else if (localStorage.getItem('IAgree') === "true") {
                if (process.env.REACT_APP_PORTAL == "employer") {
                    sessionStorage.setItem('EMPLOYER_FLOW', 'YES');
                    localStorage.setItem("IAgree", "true");
                    this.props.history.push(`/manage-prospects?empid=${sessionStorage.getItem('loggedInEmpId')}`);
                } else {
                const user = await Auth.currentAuthenticatedUser();
                const isSwitch = !!localStorage.getItem('SwitchAccount');
                const data = isSwitch ? JSON.parse(localStorage.getItem('SwitchAccount')) : this.parseJwt(user.signInUserSession.idToken.jwtToken);
                const name = data.name.split(' ');
                const obj = {
                    firstName: name[0],
                    lastName: name[1],
                    phone: data.phone_number,
                    email: data.email,
                    clientId: parseInt(data["custom:ChannelId"]),
                    associationId: data["custom:associationId"],
                    brokerId: isSwitch ? localStorage.getItem("brokerID") : data["custom:agentid"]
                };
                if (!data["custom:ChannelId"]) throw new Error(window.errorMessage('Channel-Id'));
                if (!data["custom:agentid"] && !localStorage.getItem("brokerID")) throw new Error(window.errorMessage('Agent-Id'));
    
                sessionStorage.setItem('email', user.attributes.email);
                sessionStorage.setItem('switchedEmail', data.email);
                sessionStorage.setItem('USER_NAME', name.join(' '));
                sessionStorage.setItem('username', data.name);
                sessionStorage.setItem('phone', data.phone_number);
    
                const parentData = this.parseJwt(user.signInUserSession.idToken.jwtToken);
                this.setState({ parentBrokerId: parentData["custom:agentid"], parentClientId: parseInt(parentData["custom:ChannelId"]) });
                sessionStorage.setItem('parentBrokerId', parentData["custom:agentid"]);
    
                this.props.setUserData(obj.brokerId, obj.clientId, obj.associationId);
    
                const clientRes = await axios.get(`${configurations.baseUrl}/employer/getClientInfo/${obj.clientId}`);
                const userData = clientRes.data.response;
                if (!userData) throw new Error(window.errorMessage('Client Info'));
    
                const agentRes = await axios.get(`${configurations.baseUrl}/agentlogin/getAgentById/${obj.brokerId}`);
                const agentData = agentRes.data.response;
                if (!agentData) throw new Error(window.errorMessage('Agent data is empty'));
    
                this.setState({
                    associationId: agentData.associationId,
                    defaultEmpid: agentData.defaultEmpid || '',
                    agentId: agentData.brokerId,
                    userLoggedIn: true,
                    clientId: userData.clientId,
                    clientName: userData.clientName,
                    role: userData.role || "Agent",
                });
    
                if (isSwitch) {
                    sessionStorage.setItem('switchedEmail', agentData.email);
                } else {
                    localStorage.setItem("parentClientName", userData.clientName);
                }
    
                sessionStorage.setItem('USER_DATA', JSON.stringify({
                    agentId: agentData.brokerId,
                    clientId: userData.clientId,
                    associationId: agentData.associationId,
                    clientName: userData.clientName,
                    defaultEmpid: agentData.defaultEmpid || '',
                    role: agentData.role || "Agent"
                }));
    
                sessionStorage.setItem('clientName', userData.clientName);
                sessionStorage.setItem('customerServiceNo', userData.customerServiceNo);
    
                this.getTopBarData(agentData.clientId);
            }
            } else {
                await Auth.signOut();
                localStorage.clear();
                sessionStorage.clear();
                this.props.history.push("/login");
            }
    
        } catch (error) {
            console.error('Error during component mounting:', error);
            this.showErrorDialog(String(error));
        }
    }
    
getTopBarData = (clientId) => {
    axios.get(process.env.REACT_APP_BASE_URL + '/employer/getClientInfo/' + clientId).then(response => {
       const typesOfClients = response.data.response.clientType?.replace("Agents,","").split(",") || ["Households"];
            const params = new URLSearchParams(window.location.search);
            const transformedArray = typesOfClients.map(item => ({
                label: `Work with ${item}`
              }));
              sessionStorage.setItem("modeList", JSON.stringify(transformedArray))
            const empid = params.get("empid");
            if(!this.state.mode && window.location.pathname === "/"){
                this.setState({mode: transformedArray[0].label}, () => {
                    this.navigate()
                })
            } else if (window.location.pathname === "/manage-prospects" && !empid) {
                this.setState({mode:  transformedArray[0].label}, () => {
                    this.navigate()
                })
            } else if (window.location.pathname === "/manage-employers" || empid) {
                this.setState({mode: transformedArray[1].label}, () => {
                    this.navigate()
                })
            }
    })
}
navigate = () => {
    if(this.state.mode)
    sessionStorage.setItem("mode", this.state.mode)
    if(this.state.mode === "Work with Employers"){
        window.location.href = "/manage-employers"
    } else if (this.state.mode === "Work with Households"){
        window.location.href = "/manage-prospects"
    }
}


    parseJwt = (id_token) => {

        let base64Url = id_token.split('.')[1];

        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

        let jsonPayload = decodeURIComponent(

            atob(base64)

                .split('')

                .map(function (c) {

                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)

                })

                .join('')

        );

        let token = JSON.parse(jsonPayload);
        return token;
    };
    handleDialogClose = async () => {
        await Auth.signOut();
        localStorage.clear();
        sessionStorage.clear();
        this.props.history.push("/login");
        this.setState({ errorDialogOpen: false });
    };
    render() {
        const { loaderShow, errorDialogOpen, errorMessage } = this.state;
        return(
            <div>
                {
                    this.state.userLoggedIn ?
                    <div>
                        {
                            this.state.loaderShow ? <><ShimmerDashboard/></> : ''
                        }
                        <Header hideResource={true} agentId={this.state.agentId} clientId={this.state.clientId} associationId={this.state.associationId} clientName={this.state.clientName} bottomMargin={'30px'}></Header>
                        {/* <AgentHome parentClientId={this.state.parentClientId} parentBrokerId={this.state.parentBrokerId} agentId={this.state.agentId} clientId={this.state.clientId} associationId={this.state.associationId} clientName={this.state.clientName} defaultEmpid={this.state.defaultEmpid}></AgentHome> */}
                   
                      
                    </div> :null
                }
                            <ErrorDialog 
                                open={errorDialogOpen} 
                                message={errorMessage} 
                                buttonText={"Logout"}
                                onClose={() => this.handleDialogClose()} 
                            />
            </div>
        )

    }
}
const mapStateToProps = state => {
    return {
        agentId: state.agentId,
        clientId: state.clientId,
        associationId: state.associationId,
        clientName : state.clientName
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setUserData: (agentId, clientId, associationId, clientName) => dispatch({ type: 'SET_USER_DATA', agentId: agentId, clientId: clientId, associationId: associationId, clientName : sessionStorage.getItem('clientName') })
    }
}


export default (connect(mapStateToProps, mapDispatchToProps)(RootComponent));